import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import client, { endpoints } from '../api/client';
import VoteButtons from '../components/VoteButtons';

export default function QuestionDetail() {
  const { slug } = useParams();
  const { user } = useSelector((s) => s.auth);
  const [q, setQ] = useState(null);
  const [answer, setAnswer] = useState('');
  const [err, setErr] = useState(null);

  useEffect(() => { client.get(endpoints.questions.get(slug)).then(({ data }) => setQ(data.question)).catch(() => setQ(false)); }, [slug]);

  const canAccept = q && user && q.author && (user.id === q.author.id || user._id === q.author.id || user.role === 'admin');

  async function postAnswer(e) {
    e.preventDefault(); setErr(null);
    try { const { data } = await client.post(endpoints.questions.answer(slug), { body: answer }); setQ(data.question); setAnswer(''); }
    catch (e) { setErr(e?.response?.data?.error || 'Failed'); }
  }
  async function accept(answerId) {
    const { data } = await client.post(endpoints.questions.accept(slug), { answerId });
    setQ({ ...q, answers: q.answers.map((a) => ({ ...a, accepted: a.id === data.acceptedId })) });
  }

  if (q === false) return <div className="container community"><h1>Question not found</h1><Link to="/questions">← All questions</Link></div>;
  if (!q) return <div className="container community"><p className="muted">Loading…</p></div>;

  return (
    <div className="container community narrow">
      <h1>{q.title}</h1>
      <p className="muted">Asked by {q.author?.name} · {q.views} views</p>
      <div className="post">
        <VoteButtons path={endpoints.questions.vote(slug)} score={q.score} myVote={q.myVote} />
        <div className="post-body"><div dangerouslySetInnerHTML={{ __html: q.bodyHtml }} /><div className="tags">{(q.tags || []).map((t) => <span key={t} className="tag">{t}</span>)}</div></div>
      </div>

      <h2>{q.answers.length} {q.answers.length === 1 ? 'Answer' : 'Answers'}</h2>
      {q.answers.map((a) => (
        <div key={a.id} className={`post answer ${a.accepted ? 'accepted' : ''}`}>
          <div className="votecol">
            <VoteButtons path={endpoints.questions.voteAnswer(slug, a.id)} score={a.score} myVote={a.myVote} />
            {a.accepted && <span className="accepted-mark" title="Accepted">✓</span>}
            {canAccept && !a.accepted && <button className="accept-btn" title="Accept this answer" onClick={() => accept(a.id)}>✓</button>}
          </div>
          <div className="post-body"><div dangerouslySetInnerHTML={{ __html: a.bodyHtml }} /><span className="byline">{a.author?.name}</span></div>
        </div>
      ))}

      <div className="add-answer">
        <h3>Your answer</h3>
        {user ? (
          <form onSubmit={postAnswer}>
            <textarea rows={6} value={answer} onChange={(e) => setAnswer(e.target.value)} placeholder="Write your answer…" />
            <button className="btn-primary">Post your answer</button>
            {err && <p className="err">{err}</p>}
          </form>
        ) : <p className="muted"><Link to="/login">Sign in</Link> to answer or vote.</p>}
      </div>
    </div>
  );
}
